import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCoTwkW8KcNshUfZFGJ1OOqB7kOkhfrQnQ",
  authDomain: "obracore-platform.firebaseapp.com",
  projectId: "obracore-platform",
  storageBucket: "obracore-platform.firebasestorage.app",
  messagingSenderId: "903863370494",
  appId: "1:903863370494:web:f61aae657c6c79dda8dbaf",
  measurementId: "G-BPJQBNCGGE",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");